import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Medico from '@/components/Medico'
import MedicoEdit from '@/components/MedicoEdit'
import MedicoNew from '@/components/MedicoNew'
import Empresa from '@/components/Empresa'
import EmpresaEdit from '@/components/EmpresaEdit'
import EmpresaNew from '@/components/EmpresaNew'
import ResultadoList from '@/components/ResultadoList'
// import ResultadoCardList from '@/components/ResultadoCardList'
import ResultadoPacienteCardList from '@/components/ResultadoPacienteCardList'
import ResultadoPaciente from '@/components/ResultadoPaciente'
import CartaoAcesso from '@/components/CartaoAcesso'
import ResultadoShareCard from '@/components/ResultadoShareCard'
import NotFound from '@/components/NotFound'
import Login from '@/components/Login'
import RedefinirSenha from '@/components/RedefinirSenha'
import Usuario from '@/components/Usuario'
import UsuarioEdit from '@/components/UsuarioEdit'
import UsuarioNew from '@/components/UsuarioNew'
import Unidade from '@/components/Unidade'
import UnidadeEdit from '@/components/UnidadeEdit'
import UnidadeNew from '@/components/UnidadeNew'
import Menu from '@/components/Menu'
import MenuEdit from '@/components/MenuEdit'
import MenuNew from '@/components/MenuNew'
import axios from 'axios'

Vue.use(Router)

var isLogged = function (to, from, next) {
  console.log('islogged ' + (window.localStorage.getItem('token') != null))
  if (to.query.access_token) {
    console.log('to.query.access_token', to.query.access_token)
    window.localStorage.setItem('token', to.query.access_token)
    axios.defaults.headers.common['X-Auth-Token'] = window.localStorage.getItem('token')
    console.log('localstprage', window.localStorage.getItem('token'))
  }
  if (window.localStorage.getItem('token')) {
    console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    axios.get('/validarToken')
      .then(response => {
        next()
      })
      .catch(e => {
        window.localStorage.removeItem('token')
        axios.defaults.headers.common['X-Auth-Token'] = null
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      })
  } else {
    var login = '/login'
    if (to.params.empresa) {
      login += `/${to.params.empresa}`
    }
    next({
      path: login,
      query: {
        redirect: to.fullPath
      }
    })
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      beforeEnter: isLogged
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/login/:e',
      name: 'LoginEmpresa',
      component: Login
    },
    {
      path: '/redefinir-senha',
      name: 'RedefinirSenha',
      component: RedefinirSenha
    },
    {
      path: '/redefinir-senha/:code',
      name: 'RedefinirSenha',
      component: RedefinirSenha
    },
    {
      path: '/notFound',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/admin/resultado',
      name: 'ResultadoList',
      component: ResultadoList,
      beforeEnter: isLogged
    },
    {
      path: '/resultado/:resultado',
      name: 'ResultadoPaciente',
      component: ResultadoPaciente
    },
    {
      path: '/cartao-acesso/:resultado',
      name: 'CartaoAcesso',
      component: CartaoAcesso,
      beforeEnter: isLogged
    },
    {
      path: '/resultado-compartilhado/:share/:empresa',
      name: 'ResultadoShareCard',
      component: ResultadoShareCard,
      beforeEnter: isLogged
    },
    {
      path: '/resultados',
      name: 'ResultadoPacienteCardList',
      component: ResultadoPacienteCardList,
      beforeEnter: isLogged
    },
    /*
        {
          path: '/resultado/:usuario/:cpf',
          name: 'ResultadoPacienteCardList',
          component: ResultadoCardList,
          beforeEnter: isLogged
        },
        {
          path: '/resultado/:empresa/:cpf/:exame',
          name: 'ResultadoPacienteExameCardList',
          component: ResultadoCardList,
          beforeEnter: isLogged
        },
    */
    {
      path: '/admin/empresa',
      name: 'Empresa',
      component: Empresa,
      beforeEnter: isLogged
    },
    {
      path: '/admin/empresa/new',
      name: 'EmpresaNew',
      component: EmpresaNew,
      beforeEnter: isLogged
    },
    {
      path: '/admin/empresa/edit/:id',
      name: 'EmpresaEdit',
      component: EmpresaEdit,
      beforeEnter: isLogged
    },
    {
      path: '/admin/unidade',
      name: 'Unidade',
      component: Unidade,
      beforeEnter: isLogged
    },
    {
      path: '/admin/unidade/new',
      name: 'UnidadeNew',
      component: UnidadeNew,
      beforeEnter: isLogged
    },
    {
      path: '/admin/unidade/edit/:id',
      name: 'UnidadeEdit',
      component: UnidadeEdit,
      beforeEnter: isLogged
    },
    {
      path: '/admin/medico',
      name: 'Medico',
      component: Medico,
      beforeEnter: isLogged
    },
    {
      path: '/admin/medico/new',
      name: 'MedicoNew',
      component: MedicoNew,
      beforeEnter: isLogged
    },
    {
      path: '/admin/medico/edit/:id',
      name: 'MedicoEdit',
      component: MedicoEdit,
      beforeEnter: isLogged
    },
    {
      path: '/admin/usuario',
      name: 'Usuario',
      component: Usuario,
      beforeEnter: isLogged
    },
    {
      path: '/admin/usuario/new',
      name: 'UsuarioNew',
      component: UsuarioNew,
      beforeEnter: isLogged
    },
    {
      path: '/admin/usuario/edit/:id',
      name: 'UsuarioEdit',
      component: UsuarioEdit,
      beforeEnter: isLogged
    },
    {
      path: '/admin/menu',
      name: 'Menu',
      component: Menu,
      beforeEnter: isLogged
    }, {
      path: '/admin/menu/new',
      name: 'MenuNew',
      component: MenuNew,
      beforeEnter: isLogged
    }, {
      path: '/admin/menu/edit/:id',
      name: 'MenuEdit',
      component: MenuEdit,
      beforeEnter: isLogged
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js